// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable multiline-comment-style */
import { PriceParamsServer } from "../records/Price"
import { Insurance } from "../components/CommonInsurance/services/utils"

export const INSURANCE_NAMES: Record<string, Insurance> = {
  NONE: "none",
  BASIC: "basic",
  PLUS: "plus",
  COVER_MORE: "travelex",
  AXA_US: "axa_us",
  US_NONE: "us_none",
}

export const SORTED_INSURANCE_LEVELS: Insurance[] = ["none", "basic", "plus"]

export const INSURANCE_NAMES_TRANSLATED = {
  /* $FlowFixMe This comment suppresses an error found when upgrading Flow to
   * v0.118.0. To view the error, delete this comment and run Flow. */
  // @ts-expect-error: Flow to TS migration.
  [INSURANCE_NAMES.NONE]: __("booking.passenger.insurance.variant_none"),
  /* $FlowFixMe This comment suppresses an error found when upgrading Flow to
   * v0.118.0. To view the error, delete this comment and run Flow. */
  // @ts-expect-error: Flow to TS migration.
  [INSURANCE_NAMES.BASIC]: __("booking.passenger.insurance.variant_skysilver_kiwi"),
  /* $FlowFixMe This comment suppresses an error found when upgrading Flow to
   * v0.118.0. To view the error, delete this comment and run Flow. */
  // @ts-expect-error: Flow to TS migration.
  [INSURANCE_NAMES.PLUS]: __("booking.passenger.insurance.variant_skygold_kiwi"),
  /* $FlowFixMe This comment suppresses an error found when upgrading Flow to
   * v0.118.0. To view the error, delete this comment and run Flow. */
  // @ts-expect-error: Flow to TS migration.
  [INSURANCE_NAMES.COVER_MORE]: __("mmb.insurance.travelex.short"),
  /* $FlowFixMe This comment suppresses an error found when upgrading Flow to
   * v0.118.0. To view the error, delete this comment and run Flow. */
  // @ts-expect-error: Flow to TS migration.
  [INSURANCE_NAMES.US_NONE]: __("mmb.insurance.none"),
} as const

export type InsuranceOptionSegment = {
  options: string[]
  optionsRedesign: string[]
  price: PriceParamsServer
}

export type InsuranceData = Partial<Record<Insurance, InsuranceOptionSegment>>
